import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
    Button,
    Card,
    Col,
    Container,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Spinner,
} from "reactstrap";
import CreateMomentoModal from "../../components/CreateMomentoModal";
import LargeSizeMomentos from "../../components/LargeSizeMomentos";
import SmallSizeMomento from "../../components/SmallSizeMomento";
import {
    createMomentosAction,
    isManagerExist,
} from "../../store/actions/MomentosActions";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { createDraftMomentosAction } from "../../store/actions/DraftDataAction";
import { LoadModal } from "../../store/actions/QrAction";
import Paypal from "../../components/PaypalPayment";

const CreateMomentos = () => {
    let history = useHistory();
    const dispatch = useDispatch();
    const { id } = useParams();
    const { loading } = useSelector((state) => state.momentos);
    const { showModal } = useSelector((state) => state.qrReducer);
    const { uid, user } = useSelector((state) => state.authUser);
    const [title, setTitle] = useState("");
    const [sellerModal, setSellerModal] = useState(true);
    const [acceptedRules, setAcceptedRules] = useState(false);
    const [description, setDescription] = useState("");
    const [managerEmail, setManagerEmail] = useState("");
    const [isChecked, setisChecked] = useState(false);
    const [momentoSize, setMomentoSize] = useState("");
    const [schoolName, setSchoolName] = useState("");
    const draftData = useSelector((state) => state.draftReducer);
    const [spinner, setSpinner] = useState(false);
    const [purchaseMomento, setPurchaseMemento] = useState(false);
    const [momentoAmount, setMomentoAmount] = useState();
    // const [myFormData, setmFormData] = useState({});
    // console.log("myFormData: ", myFormData);

    const [largeMomentos, setLargeMomentos] = useState([
        {
            title: "",
            subTitle: "",
            media: "",
        },
        {
            title: "",
            subTitle: "",
            media: "",
        },
        {
            title: "",
            subTitle: "",
            media: "",
        },
    ]);
    const [smallMomentos, setSmallMomentos] = useState([
        {
            title: "",
            subTitle: "",
            media: "",
        },
        {
            title: "",
            subTitle: "",
            media: "",
        },
    ]);
    const [QrCodeLarge, setQrCodeLarge] = useState([
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
    ]);
    const [QrCodeSmall, setQrCodeSmall] = useState([
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
    ]);
    const clearData = () => {
        setManagerEmail("");
        setDescription("");
        setTitle("");
        setMomentoAmount();
        setSchoolName("");
        setMomentoSize("");
        setLargeMomentos([
            {
                title: "",
                subTitle: "",
                media: "",
            },
            {
                title: "",
                subTitle: "",
                media: "",
            },
            {
                title: "",
                subTitle: "",
                media: "",
            },
        ]);
        setQrCodeLarge(["", "", "", "", "", "", "", "", "", "", ""]);
        setQrCodeSmall(["", "", "", "", "", "", "", "", ""]);
        setSmallMomentos([
            {
                title: "",
                subTitle: "",
                media: "",
            },
            {
                title: "",
                subTitle: "",
                media: "",
            },
        ]);
    };

    const handleSubmit = (props) => {
        const momentos = momentoSize == 14 ? largeMomentos : smallMomentos;
        const qrCodes = momentoSize == 14 ? QrCodeLarge : QrCodeSmall;
        if (!uid || !momentoSize || !title || !description) {
            toast.error("Fill in the title and descrition for Memento");
            return;
        }
        if (
            momentos.some((item) => item.title == "") ||
            momentos.some((item) => item.subTitle == "") ||
            momentos.some((item) => item.media == "")
        ) {
            toast.error(
                "Please fill All the title, subtitles and media for the cards"
            );
        } else if (user?.schoolAdminId && !schoolName) {
            toast.error("Please, fill the school Name ");
        } else if (!momentoAmount) {
            toast.error("Please, fill the Momento Amount ");
        } else {
            let payload = {
                athlete_id: uid,
                athleteID: user?.athleteID,
                athleteName: user?.first_name + " " + user?.last_name,
                momentoSize,
                momentoTitle: title,
                momentoAmount: momentoAmount,
                momentoDescription: description,
                schoolName: user?.schoolAdminId ? schoolName : null,
                momento: momentos,
                qrCodes: qrCodes,
                managerRating: false,
            };
            if (id !== " ") {
                payload.requestId = id;
            }
            if (props.payment_id) {
                payload.payment_id = props.payment_id;
            }
            if (managerEmail) {
                dispatch(
                    isManagerExist(managerEmail, () => {
                        payload.managerEmail = managerEmail;
                        dispatch(
                            createMomentosAction(uid, payload, () => {
                                toast.success("Memento Added successfully");
                                clearData();
                            })
                        );
                    })
                );
            } else {
                dispatch(
                    createMomentosAction(uid, payload, () => {
                        toast.success("Memento Added successfully");
                        clearData();
                    })
                );
            }
        }
    };
    const onPurchaseSuccess = (details) => {
        const newFormData = {
            payment_id: details?.id || "",
        };
        handleSubmit(newFormData);
    };

    const handleDraftData = () => {
        setSpinner(true);
        const momentos = momentoSize == 14 ? largeMomentos : smallMomentos;
        const qrCodes = momentoSize == 14 ? QrCodeLarge : QrCodeSmall;

        let payload = {
            athlete_id: uid,
            athleteID: user?.athleteID,
            athleteName: user?.first_name + " " + user?.last_name,
            momentoSize,
            momentoTitle: title || "Default Title",
            momentoAmount: momentoAmount,
            momentoDescription: description,
            schoolName: user?.schoolAdminId ? schoolName : null,
            momento: momentos,
            qrCodes: qrCodes,
            managerRating: false,
        };
        if (id !== " ") {
            payload.requestId = id;
        }
        dispatch(
            createDraftMomentosAction(uid, payload, () => {
                toast.success("Memento Added in Draft successfully");
                setSpinner(false);
                clearData();
            })
        );
    };

    const [checkMomento, setCheckMomento] = useState(false);
    const [schoolIntellectual, setSchoolIntellectual] = useState({
        uniform: false,
        logo: false,
        venue: false,
        scenes: false,
        event: false,
        intellectual: false,
        noIntellectual: false,
    });

    const toggleCheckMomentoModal = () => {
        setCheckMomento(!checkMomento);
    };
    const handleSubmitMomento = (e) => {
        if (
            schoolIntellectual.uniform ||
            schoolIntellectual.logo ||
            schoolIntellectual.venue ||
            schoolIntellectual.scenes ||
            schoolIntellectual.event ||
            schoolIntellectual.intellectual
        ) {
            if (user?.schoolAdminId) {
                toggleCheckMomentoModal();
                if (user?.momentoCount >= 5) {
                    setPurchaseMemento(true);
                } else {
                    handleSubmit(e);
                }
            } else {
                toast.warning("Please attach with school for make this badge");
            }
        } else {
            toggleCheckMomentoModal();
            if (user?.momentoCount >= 5) {
                setPurchaseMemento(true);
            } else {
                handleSubmit(e);
            }
        }
    };

    const handleCheckMomento = (e) => {
        const momentos = momentoSize == 14 ? largeMomentos : smallMomentos;
        if (!uid || !momentoSize || !title || !description) {
            toast.error("Fill in the title and descrition for Memento");
            return;
        }
        if (
            momentos.some((item) => item.title == "") ||
            momentos.some((item) => item.subTitle == "") ||
            momentos.some((item) => item.media == "")
        ) {
            toast.error(
                "Please fill All the title, subtitles and media for the cards"
            );
        } else if (user?.schoolAdminId && !schoolName) {
            toast.error("Please, fill the school Name ");
        } else if (!momentoAmount) {
            toast.error("Please, fill the Momento Amount ");
        } else {
            toggleCheckMomentoModal();
        }
    };

    return (
        <Container fluid className="px-5 create_momento">
            {acceptedRules && !sellerModal && (
                <>
                    <Row className="justify-content-center py-4">
                        <CreateMomentoModal
                            setMomentoSize={setMomentoSize}
                            setPurchaseMemento={setPurchaseMemento}
                        />
                    </Row>

                    {momentoSize && (
                        <>
                            <Container fluid>
                                <Card className="mb-5 p-4 create_momento-card">
                                    <Row className="justify-content-end gap-6">
                                        <Row className="justify-content-around w-25">
                                            <Button
                                                style={{
                                                    width: "fit-content",
                                                    alignSelf: "end",
                                                }}
                                                color="primary"
                                                size="sm"
                                                disabled={
                                                    !title ||
                                                    !description ||
                                                    !momentoAmount
                                                }
                                                onClick={handleDraftData}
                                            >
                                                {!spinner ? (
                                                    "Save"
                                                ) : (
                                                    <Spinner size="sm" />
                                                )}
                                            </Button>
                                            <Button
                                                style={{
                                                    width: "fit-content",
                                                    alignSelf: "end",
                                                }}
                                                color="primary"
                                                size="sm"
                                                onClick={(e) => {
                                                    setisChecked(true);
                                                    if (!showModal) {
                                                        setTimeout(() => {
                                                            window.open(
                                                                "https://www.qrcodechimp.com/",
                                                                "_blank"
                                                            );
                                                        }, 500);
                                                    }
                                                }}
                                            >
                                                Generate QR Code
                                            </Button>
                                        </Row>
                                    </Row>
                                    <Row className="flex-column justify-content-center align-items-center p-2">
                                        <Col lg={10} md={10} sm={10}>
                                            <h3 className="text-center mb-3">
                                                Create Memento
                                            </h3>
                                            <Row className="justify-content-center justify-content-lg-between align-items-center p-2">
                                                <Col
                                                    lg={3}
                                                    sm={10}
                                                    className="mb-3 mb-lg-0"
                                                >
                                                    <Input
                                                        placeholder="Enter Memento Title"
                                                        type="text"
                                                        maxLength={47}
                                                        value={title}
                                                        onChange={(e) =>
                                                            setTitle(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </Col>
                                                <Col lg={3} sm={10}>
                                                    <Input
                                                        type="text"
                                                        placeholder="Enter Memento Description"
                                                        value={description}
                                                        onChange={(e) =>
                                                            setDescription(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </Col>
                                                <Col lg={3} sm={10}>
                                                    <Input
                                                        type="text"
                                                        placeholder="Enter Manager Email"
                                                        value={managerEmail}
                                                        onChange={(e) =>
                                                            setManagerEmail(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </Col>
                                                <Col lg={3} sm={10}>
                                                    <Input
                                                        type="number"
                                                        placeholder="Enter Momento Amount"
                                                        min={1}
                                                        value={momentoAmount}
                                                        onChange={(e) =>
                                                            setMomentoAmount(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    {momentoSize && momentoSize == 14 ? (
                                        <LargeSizeMomentos
                                            momento={largeMomentos}
                                            setMomento={setLargeMomentos}
                                            QRCODES={QrCodeLarge}
                                            setQRCODES={setQrCodeLarge}
                                        />
                                    ) : (
                                        <SmallSizeMomento
                                            momento={smallMomentos}
                                            setMomento={setSmallMomentos}
                                            QRCODES={QrCodeSmall}
                                            setQRCODES={setQrCodeSmall}
                                        />
                                    )}

                                    {user?.schoolAdminId && (
                                        <Row className="flex-column justify-content-center align-items-center p-2">
                                            <Col lg={10} md={10} sm={10}>
                                                <Row className="justify-content-lg-end justify-content-md-center align-items-center p-2">
                                                    <Col
                                                        lg={4}
                                                        sm={10}
                                                        className="my-3 mb-lg-0"
                                                    >
                                                        <Input
                                                            placeholder="Enter school name"
                                                            type="text"
                                                            maxLength={47}
                                                            value={schoolName}
                                                            onChange={(e) =>
                                                                setSchoolName(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    )}

                                    <Row
                                        xs="1"
                                        className="flex-column text-center my-4"
                                    >
                                        <Col>
                                            <Button
                                                color="warning"
                                                className="text-white"
                                                onClick={() => {
                                                    handleCheckMomento();
                                                    setSchoolIntellectual({
                                                        uniform: false,
                                                        logo: false,
                                                        venue: false,
                                                        scenes: false,
                                                        event: false,
                                                        intellectual: false,
                                                        noIntellectual: false,
                                                    });
                                                }}
                                                disabled={purchaseMomento}
                                            >
                                                {loading ? (
                                                    <Spinner
                                                        size="sm"
                                                        className="mx-5"
                                                    />
                                                ) : (
                                                    "Add Memento"
                                                )}
                                            </Button>
                                        </Col>
                                        {purchaseMomento && (
                                            <Col>
                                                <h6 className="text-center text-danger my-2">
                                                    You have reached your limit
                                                    of free posts, pay $0.50 to
                                                    continue.
                                                </h6>
                                                <Button className="bg-transparent p-0 border-0">
                                                    <Paypal
                                                        amount={0.5}
                                                        onPurchaseSuccess={
                                                            onPurchaseSuccess
                                                        }
                                                    />
                                                </Button>
                                            </Col>
                                        )}
                                    </Row>
                                </Card>
                            </Container>

                            {isChecked && showModal && (
                                <Modal
                                    isOpen={isChecked && showModal}
                                    toggle={() => history.goBack()}
                                    tabIndex="-1"
                                    size="xl"
                                >
                                    <ModalHeader
                                        className="text-center"
                                        toggle={() => history.goBack()}
                                    >
                                        INFO: QR Codes for your Mementos Fans
                                        love it when you put both types in your
                                        mementos Static QRs and Dynamic QRs.
                                    </ModalHeader>
                                    <ModalBody>
                                        <Row className="d-flex justify-content-center">
                                            <Col className="col-6">
                                                <div className="qr-info-section">
                                                    <h6 className="text-center">
                                                        <strong>
                                                            Static QRs
                                                        </strong>
                                                    </h6>
                                                    <p className="text-center">
                                                        <strong>
                                                            When to use?
                                                        </strong>
                                                    </p>
                                                    <p className="text-center">
                                                        <strong>
                                                            {" "}
                                                            Answer: Most of the
                                                            QR codes
                                                        </strong>{" "}
                                                        you will put on a
                                                        memento will be
                                                        "unchanging" or Static
                                                        QR codes. That's because
                                                        you will want the same
                                                        video to play each time
                                                        that Static QR code is
                                                        scanned.
                                                    </p>
                                                    <p className="text-center">
                                                        <strong>
                                                            Where to get static
                                                            QRs
                                                        </strong>
                                                    </p>
                                                    <ul>
                                                        <li>
                                                            https://new.express.adobe.com/tools/generate-qr-code
                                                        </li>
                                                        <li>
                                                            Qrcodechimp.com -
                                                            your free plan link
                                                        </li>
                                                    </ul>
                                                </div>
                                            </Col>
                                            <Col className="col-6">
                                                <div className="qr-info-section">
                                                    <h6 className="text-center">
                                                        <strong>
                                                            {" "}
                                                            Dynamic QRs
                                                        </strong>
                                                    </h6>
                                                    <p className="text-center">
                                                        <strong>
                                                            When to use?
                                                        </strong>
                                                    </p>
                                                    <p className="text-center">
                                                        <strong>
                                                            {" "}
                                                            Now, let's say the
                                                            fan
                                                        </strong>
                                                        has one of your mementos
                                                        on their wall. They
                                                        scanned each QR and
                                                        enjoyed the videos.
                                                        <strong>
                                                            {" "}
                                                            But you have new
                                                            something to tell
                                                            them
                                                        </strong>
                                                        . If you remembered to
                                                        put a dynamic QR in the
                                                        memento when you made
                                                        it, you can edit it and
                                                        the fan can
                                                        <strong>
                                                            {" "}
                                                            use the old memento
                                                            to see a new video
                                                        </strong>
                                                        Here's how:
                                                    </p>
                                                    <p className="text-center">
                                                        <strong>
                                                            Where to get dynamic
                                                            QRs
                                                        </strong>
                                                    </p>
                                                    <ul>
                                                        <li>
                                                            Qrcodechimp.com -
                                                            your free plan link
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Where to edit
                                                            </strong>{" "}
                                                            (i.e., to put in the
                                                            new video)?
                                                        </li>
                                                        <li>
                                                            Edit button at
                                                            Qrcodechimp.com -
                                                            your free plan
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Where to learn
                                                                fast?
                                                            </strong>{" "}
                                                            - Watch the video
                                                        </li>
                                                        <li>
                                                            https://www.loom.com/share/5a124172ee814eb627f93b358cd7b5c80
                                                        </li>
                                                    </ul>
                                                </div>
                                            </Col>
                                        </Row>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button
                                            size="sm"
                                            color="danger"
                                            onClick={() => {
                                                dispatch(LoadModal(false));
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            size="sm"
                                            color="primary"
                                            disabled={!isChecked}
                                            onClick={() => {
                                                dispatch(LoadModal(false));
                                                setTimeout(() => {
                                                    window.open(
                                                        "https://www.qrcodechimp.com/",
                                                        "_blank"
                                                    );
                                                }, 500);
                                            }}
                                        >
                                            OK
                                        </Button>
                                    </ModalFooter>
                                </Modal>
                            )}
                        </>
                    )}
                </>
            )}
            <Modal isOpen={sellerModal} toggle={() => history.goBack()}>
                <ModalHeader toggle={() => history.goBack()}>
                    Rules For Athlete Sellers of Mementos
                </ModalHeader>
                <ModalBody>
                    <ol className="notice__list" type="A">
                        <li>
                            I understand that all sellers must be 18 years or
                            parent-approved.
                        </li>
                        <li>
                            I understand that the content of text and photos in
                            the mementos I post in the gallery, and the content
                            of videos, etc. linked to memento QR codes I post in
                            the gallery, must be wholesome and
                            non-objectionable.
                        </li>
                        <li>
                            I understand FHP is under no obligation to keep my
                            memento on sale at the gallery.
                        </li>
                        <li>
                            I understand that FHP in its sole discretion may
                            remove any memento from the gallery at any time
                            without notice to me.
                        </li>
                    </ol>
                    <FormGroup check inline>
                        <Label check className="ml-4 mr-2">
                            Click to signify agreement:
                        </Label>
                        <Input
                            className="mb-0"
                            type="checkbox"
                            checked={acceptedRules}
                            onClick={() => setAcceptedRules(!acceptedRules)}
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button
                        size="sm"
                        color="danger"
                        onClick={() => history.goBack()}
                    >
                        Cancel
                    </Button>
                    <Button
                        size="sm"
                        color="primary"
                        disabled={!acceptedRules}
                        onClick={() => setSellerModal(false)}
                    >
                        OK
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal
                isOpen={checkMomento}
                toggle={toggleCheckMomentoModal}
                size="lg"
            >
                <ModalBody>
                    <h2 className="text-center">
                        In this Memento, which School Intellectual Property did
                        you use?
                    </h2>
                    <div className="d-flex mt-4 ml-4">
                        <Input
                            type="checkbox"
                            className="custom-checkbox"
                            checked={schoolIntellectual.uniform}
                            onChange={(e) =>
                                setSchoolIntellectual((prev) => ({
                                    ...prev,
                                    uniform: e.target.checked,
                                }))
                            }
                        />
                        <Label className="custom-checkbox-label text-dark mx-2">
                            I appeared in my school jersey/uniform.
                        </Label>
                    </div>
                    <div className="d-flex mt-4 ml-4">
                        <Input
                            type="checkbox"
                            className="custom-checkbox"
                            checked={schoolIntellectual.logo}
                            onChange={(e) =>
                                setSchoolIntellectual((prev) => ({
                                    ...prev,
                                    logo: e.target.checked,
                                }))
                            }
                        />
                        <Label className="custom-checkbox-label text-dark mx-2">
                            School logo in memento or linked video.
                        </Label>
                    </div>
                    <div className="d-flex mt-4 ml-4">
                        <Input
                            type="checkbox"
                            className="custom-checkbox"
                            checked={schoolIntellectual.venue}
                            onChange={(e) =>
                                setSchoolIntellectual((prev) => ({
                                    ...prev,
                                    venue: e.target.checked,
                                }))
                            }
                        />
                        <Label className="custom-checkbox-label text-dark mx-2">
                            School venue in memento or linked video.
                        </Label>
                    </div>
                    <div className="d-flex mt-4 ml-4">
                        <Input
                            type="checkbox"
                            className="custom-checkbox"
                            checked={schoolIntellectual.scenes}
                            onChange={(e) =>
                                setSchoolIntellectual((prev) => ({
                                    ...prev,
                                    scenes: e.target.checked,
                                }))
                            }
                        />
                        <Label className="custom-checkbox-label text-dark mx-2">
                            Behind-the-Scenes at school appears.
                        </Label>
                    </div>
                    <div className="d-flex mt-4 ml-4">
                        <Input
                            type="checkbox"
                            className="custom-checkbox"
                            checked={schoolIntellectual.event}
                            onChange={(e) =>
                                setSchoolIntellectual((prev) => ({
                                    ...prev,
                                    event: e.target.checked,
                                }))
                            }
                        />
                        <Label className="custom-checkbox-label text-dark mx-2">
                            School event, game or match appears.
                        </Label>
                    </div>
                    <div className="d-flex mt-4 ml-4">
                        <Input
                            type="checkbox"
                            className="custom-checkbox"
                            checked={schoolIntellectual.intellectual}
                            onChange={(e) =>
                                setSchoolIntellectual((prev) => ({
                                    ...prev,
                                    intellectual: e.target.checked,
                                }))
                            }
                        />
                        <Label className="custom-checkbox-label text-dark mx-2">
                            Other intellectual property of school is used
                            (mascot, team name, etc.).
                        </Label>
                    </div>
                    <div className="d-flex mt-4 ml-4">
                        <Input
                            type="checkbox"
                            className="custom-checkbox"
                            checked={schoolIntellectual.noIntellectual}
                            onChange={(e) =>
                                setSchoolIntellectual((prev) => ({
                                    ...prev,
                                    noIntellectual: e.target.checked,
                                }))
                            }
                        />
                        <Label className="custom-checkbox-label text-dark mx-2">
                            No school intellectual property used.
                        </Label>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        size="sm"
                        color="danger"
                        onClick={toggleCheckMomentoModal}
                    >
                        Cancel
                    </Button>
                    <Button
                        size="sm"
                        color="primary"
                        onClick={handleSubmitMomento}
                    >
                        Submit
                    </Button>
                </ModalFooter>
            </Modal>
        </Container>
    );
};

export default CreateMomentos;
